const blockVideo = () => {
	const videoBox = document.querySelector('.s-video__box');

	if (videoBox) {
		const video = videoBox.querySelector('.s-video__video');
		const playbtn = videoBox.querySelector('.c-btn--player');
		const btnbox = videoBox.querySelector('.s-video__play-btn-box');

		playbtn.addEventListener('click', (event) => {
			event.preventDefault();
			if (video.paused) {
				video.play();
				btnbox.classList.add('s-video__play-btn-box--off');
			}
		});

		video.addEventListener('click', () => {
			if (!video.paused) {
				video.pause();
				btnbox.classList.remove('s-video__play-btn-box--off');
			}
		});
	}
};

export default blockVideo;
